import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { FullPageLoader } from "@/components/Logo";
import { api, errorMessage } from "@/lib/api";

export default function AppHome() {
  const [target, setTarget] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/workspaces").then(({ data }) => {
      const real = data.workspaces.filter((w) => !w.is_sample);
      const last = localStorage.getItem("evr_last_ws");
      const pick = real.find((w) => w.id === last) || real[0];
      setTarget(pick ? `/app/w/${pick.id}` : "/app/new-workspace");
    }).catch((e) => setError(errorMessage(e)));
  }, []);

  if (error) return <div data-testid="app-home-error" className="p-10 text-center text-red-700">{error}</div>;
  if (!target) return <FullPageLoader />;
  return <Navigate to={target} replace />;
}
